import {
  ResponsiveContainer,
  useFormEvents,
  usePageTitle,
  useObservable,
  BulkCancelPanel,
} from '@lib/common';
import { FormStatus, ReservationForms, bulkAvailableRateQuery } from '@lib/state';
import React from 'react';
import { useHistory } from 'react-router-dom';

const targetUrl: string = '/profile/stays';

export const BulkReservationsCancelPage: React.FC = () => {
  usePageTitle('Bulk Reservation Cancel');
  const history = useHistory();

  const [result] = useFormEvents(ReservationForms.BulkCancel);

  const { propertyId, corporateAccountId, selectedReservations } = useObservable(
    bulkAvailableRateQuery.filters
  );

  if (
    result.status === FormStatus.Success ||
    propertyId === '' ||
    corporateAccountId === '' ||
    selectedReservations.length === 0
  ) {
    history.push(targetUrl);
  }

  if (!propertyId || !corporateAccountId) return null;

  return (
    <ResponsiveContainer>
      <BulkCancelPanel
        propertyId={propertyId}
        corporateAccountId={corporateAccountId}
        selectedReservations={selectedReservations}
        formEvents={result}
      />
    </ResponsiveContainer>
  );
};
